import React from 'react';
import classNames from 'classnames';
import { useIntl } from 'umi';
import { Button, Icon } from 'tea-component';

interface IPublishZoneProps {
  publishEnabled: boolean;
  publishButtonDisabled: boolean;
  publishLoading: boolean;
  onPublish: () => void;
}

/**
 * 测试通过后的发布说明与发布按钮。
 */
const PublishZone: React.FC<IPublishZoneProps> = ({
  publishEnabled,
  publishButtonDisabled,
  publishLoading,
  onPublish,
}) => {
  const { formatMessage } = useIntl();

  return (
    <div
      className={classNames(
        'dbl-model-agent-create-step-test-publish__pub-zone',
        !publishEnabled && 'is-disabled',
      )}
    >
      <h3 className="dbl-model-agent-create-step-test-publish__pub-title">
        {formatMessage({ id: 'dbl_model_agent_step4_pub_title' })}
      </h3>
      <p className="dbl-model-agent-create-step-test-publish__pub-desc">
        {formatMessage({ id: 'dbl_model_agent_step4_pub_desc' })}
      </p>
      <div className="dbl-model-agent-create-step-test-publish__pub-actions">
        <Button
          type="primary"
          className="dbl-model-agent-create-step-test-publish__btn-pub"
          disabled={publishButtonDisabled}
          onClick={() => {
            void onPublish();
          }}
        >
          {publishLoading ? (
            <>
              <Icon
                className="dbl-model-agent-create-step-test-publish__btn-loading-icon"
                type="loading"
              />
              {formatMessage({ id: 'dbl_model_management_publish' })}
            </>
          ) : (
            formatMessage({ id: 'dbl_model_agent_step4_publish' })
          )}
        </Button>
      </div>
    </div>
  );
};

export default PublishZone;
